import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import RouteMapper from "./RouteMapper";

const RouteMapperPage = () => {
  return (
    <NavHeightAdjust>
      <RouteMapper />
    </NavHeightAdjust>
  );
};

export default RouteMapperPage;
